export const maintenanceConfig = {
    // Replace these values with your actual Statuspage API credentials
    statusPageId: 'your-statuspage-page-id', // e.g., 'h4ct6m5r2x7s'
    apiKey: 'your-statuspage-api-key', // Your OAuth API key from Statuspage
    
    // API URLs - these should not need to be changed
    publicApiUrl: 'https://status.globaltradingnetwork.com/api/v2/scheduled-maintenances.json',
    managementApiBaseUrl: 'https://api.statuspage.io/v1',
    
    // Rate limiting settings (Statuspage allows 1 request per second)
    rateLimitDelay: 1000, // milliseconds between requests
    
    // Default settings for new maintenance incidents
    defaults: {
      impact: 'minor', // minor, major, critical
      deliverNotifications: true,
      status: 'scheduled'
    }
  };
  
  /**
   * Instructions for setting up Statuspage API:
   * 
   * 1. Log in to your Statuspage dashboard
   * 2. Go to Settings > API Keys
   * 3. Create a new OAuth Application or use existing one
   * 4. Copy the API key and page ID
   * 5. Update the values above
   * 
   * For Page ID:
   * - Go to your status page dashboard
   * - The page ID is in the URL: statuspage.io/pages/{PAGE_ID}/
   * 
   * For Component IDs (used in affected components):
   * - Go to Components section in your Statuspage dashboard
   * - Each component has an ID that you can use in the maintenance form
   */ 